
import Vue from "vue";

import { Component } from "vue-property-decorator";
import Dialog from "@/components/common/Dialog/index.vue";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";
import ContrastButton from "./components/ContrastButton/index.vue";
import AccessibilityButton from "./components/AccessibilityButton/index.vue";
import LibrasButton from "./components/LibrasButton/index.vue";
import ZoomButton from "./components/ZoomButton/index.vue";

@Component({
  name: "Header",
  components: {
    Dialog,
    ContrastButton,
    ZoomButton,
    AccessibilityButton,
    LibrasButton,
  },
})
export default class Header extends Vue {
  @Action setTheme!: ActionMethod;
  @Getter isMeli!: boolean;

  showModal = false;
  isLoading = true;

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  created() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }

  showZoomModal(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:link",
        eventLabel: "acessibilidade:zoom",
      });
    }
    this.showModal = true;
  }

  closeModalAlert() {
    this.showModal = false;
  }
}
